import classNames from 'classnames'

import style from './style.scss'

type Props = {
  'aria-label'?: string
  className?: string
  disabled?: boolean
  submitText: string
  variant?:
    | 'primary'
    | 'primaryBlue'
    | 'secondaryBlack'
    | 'secondaryBlue'
    | 'secondaryWhite'
}

function Submit(props: Props) {
  const {
    'aria-label': ariaLabel,
    className,
    disabled = false,
    submitText,
    variant = 'primary',
  } = props

  return (
    <input
      aria-label={ariaLabel}
      className={classNames(style.base, style[variant], className)}
      disabled={disabled}
      type='submit'
      value={submitText}
    />
  )
}

export default Submit
